import React from "react";

interface OrangeArrowProps {
    reversed?: boolean;
    height: number;
}

export const OrangeArrow = ({ height, reversed = false }: OrangeArrowProps) => {
    return (
        <div className={`absolute w-full flex items-center ${reversed ? 'flex-col-reverse' : 'flex-col'}`}>
            <div className='bg-[#F26922]' style={{ height: `${height}px`, width: '1px' }} />
            <div className='bg-[#F26922] translate-x-[0.5px] p-1 rounded-full' />
        </div>
    );
};
